import React, { useEffect, useState } from 'react';
import { Button, Form, Message, Modal } from 'semantic-ui-react';
import { API, showError } from '../helpers';
import { getPasskeyV815 } from '../helpers/webauthnV815';

const RootStepUpModalV815 = ({ open, onClose, onVerified }) => {
  const [methods, setMethods] = useState([]);
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    setCode('');
    API.get('/api/security')
      .then((res) => {
        const data = res.data?.data || {};
        const next = [];
        if (data.totp_enabled) next.push('totp');
        if (Number(data.passkey_count) > 0) next.push('passkey');
        setMethods(next);
      })
      .catch((error) => showError(error.message));
  }, [open]);

  const finish = (expiresAt) => {
    setLoading(false);
    onVerified?.(expiresAt);
  };

  const verifyTOTP = async () => {
    setLoading(true);
    const res = await API.post('/api/security/root/step-up/totp', { code });
    if (res.data?.success) {
      finish(res.data.data?.expires_at);
    } else {
      setLoading(false);
      showError(res.data?.message);
    }
  };

  const verifyPasskey = async () => {
    setLoading(true);
    try {
      const begin = await API.post(
        '/api/security/root/step-up/passkey/begin',
        {}
      );
      if (!begin.data?.success) throw new Error(begin.data?.message);
      const ceremonyId = begin.data.data.ceremony_id;
      const credential = await getPasskeyV815(begin.data.data.options);
      const finishRes = await API.post(
        '/api/security/root/step-up/passkey/finish?ceremony_id=' +
          encodeURIComponent(ceremonyId),
        credential
      );
      if (!finishRes.data?.success) throw new Error(finishRes.data?.message);
      finish(finishRes.data.data?.expires_at);
    } catch (error) {
      setLoading(false);
      showError(error.message);
    }
  };

  return (
    <Modal open={open} onClose={onClose} size='tiny'>
      <Modal.Header>验证身份</Modal.Header>
      <Modal.Content>
        <p>使用任一种已设置的两步验证方式。验证后可查看 10 分钟。</p>
        {methods.includes('totp') && (
          <Form>
            <Form.Input
              label='动态验证码'
              value={code}
              inputMode='numeric'
              autoComplete='one-time-code'
              onChange={(_, { value }) => setCode(value)}
              action={
                <Button
                  primary
                  type='button'
                  disabled={!code}
                  loading={loading}
                  onClick={verifyTOTP}
                >
                  验证
                </Button>
              }
            />
          </Form>
        )}
        {methods.includes('passkey') && (
          <Button
            icon='fingerprint'
            content='使用 Passkey'
            loading={loading}
            onClick={verifyPasskey}
          />
        )}
        {methods.length === 0 && (
          <Message warning>
            请先在安全设置中启用动态验证码或添加 Passkey。
          </Message>
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onClose}>取消</Button>
      </Modal.Actions>
    </Modal>
  );
};

export default RootStepUpModalV815;
